const Categories = [
	{ category: "pms-adverse-events-drugs", name: "Adverse Events (Drugs)" },
	{ category: "pms-adverse-events", name: "Adverse Events (MedTech)" },
	{ category: "market-clinical-news", name: "All Market & Clinical News" },
	{ category: "product-registrations-and-approvals-drugs", name: "Approvals/Registrations (Drugs)" },
	{ category: "product-registrations-and-approvals", name: "Approvals/Registrations (MedTech)" },
	{ category: "authorities-news-ai", name: "Authorities News (Artificial intelligence (AI))" },
	{ category: "authorities-news-chemicals", name: "Authorities News (Chemicals / Materials)" },
	{ category: "authorities-news-clinical-trials", name: "Authorities News (Clinical Trials)" },
	{ category: "authorities-news-cybersecurity", name: "Authorities News (Cybersecurity)" },
	{ category: "authorities-news-data-privacy", name: "Authorities News (Data Privacy)" },
	{ category: "authorities-news-electrical-safety", name: "Authorities News (Electrical-safety)" },
	{ category: "authorities-news-emc", name: "Authorities News (EMC & Radio-frequency)" },
	{ category: "authorities-news-environmental", name: "Authorities News (Environmental, Social, and Governance (ESG))" },
	{ category: "authorities-news-packaging", name: "Authorities News (Packaging)" },
	{ category: "clinical-literature", name: "Clinical Literature" },
	{ category: "clinical-trials", name: "Clinical Trials & Studies" },
	{ category: "authorities-news-cosmetics", name: "Cosmetics Reg. News" },
	{ category: "pms-cybersecurity-alerts", name: "Cybersecurity Alerts" },
	{ category: "pms-drugs-recalls", name: "FSCAs & Recalls (Drugs)" },
	{ category: "pms-fscas", name: "FSCAs & Recalls (MedTech)" },
	{ category: "clinical-guidelines", name: "Guidelines & HTAs" },
	{ category: "inspections", name: "Inspections" },
	{ category: "inspections-documents-ora", name: "FDA 483s" },
	{ category: "press-releases", name: "Manufacturers Press Releases & News" },
	{ category: "media-publishers-news", name: "Media Companies News" },
	{ category: "authorities-news", name: "MedTech Reg. News" },
	{ category: "authorities-news-drugs", name: "Pharma Reg. News" },
	{ category: "pharmacopoeia", name: "Pharmacopoeia" },
	{ category: "pharmacopoeia-news", name: "Pharmacopoeia News" },
	{ category: "pms-safety-alerts", name: "Safety Alerts (MedTech, Pharma)" },
	{ category: "pms-shortages", name: "Shortages" },
	{ category: "software-libraries-updates", name: "Software Libraries Updates" },
	{ category: "standards-regional-adoptions", name: "Standards Country Adoptions News" },
	{ category: "technical-standards-news", name: "Standards Lifecycle News" },
	{ category: "warning-letters", name: "Warning Letters" },
	{ category: "authorities-news-all-areas", name: "Regulatory News (All Reg. Areas)" },
	{ category: "reach-substances", name: "Chemicals Substances" }
];

export default Categories;